import { useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchYearSingleForm } from "src/components/common/form/search/SearchYearSingleForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { CompanyDto } from "src/dtos/company/companyDto";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";
import { defaultPRD5030_R01Filter, usePRD5030_R01Store } from "./Store_PRD5030_R01";

export const SearchSection_PRD5030_R01 = () => {
	const { PRD5030_R01Filter, setPRD5030_R01Filter } = usePRD5030_R01Store();
	const { compCdList, workPlaceList, itemGroupList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();

	const itemCdHandleFocusId = 'prd5030_itemCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목',
			focusId: itemCdHandleFocusId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(
					searchText,
					'all',
					PRD5030_R01Filter.itemGroup || 'all',
					'all',
				);
				return itemResponse.data.data.find((value) => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: PRD5030_R01Filter.itemCd || '',
				itemNm: PRD5030_R01Filter.itemNm || '',
				itemGroup: PRD5030_R01Filter.itemGroup || 'all',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PRD5030_R01Filter,
		setEditData: setPRD5030_R01Filter,
		defaultData: defaultPRD5030_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PRD5030_R01_search',
	});

	// 연도 피커 팝업 상태
	const [yearVisible, setYearVisible] = useState(false);
	const [yearPos, setYearPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	return (
		<SearchSectionForm>
			<SearchDropDownForm<CompanyDto>
				label="사업장"
				value={PRD5030_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={(v) => setPRD5030_R01Filter({ compCd: v === 'all' ? '' : v })}
			/>

			<SearchYearSingleForm
				label="연도"
				visible={yearVisible}
				setVisible={setYearVisible}
				value={new Date(PRD5030_R01Filter.year, 0, 1)}
				onChange={(date) =>
					setPRD5030_R01Filter({ year: (date ?? new Date()).getFullYear() })
				}
				pickerPosition={yearPos}
				setPickerPosition={setYearPos}
			/>

			<SearchDropDownForm<WorkPlaceDto>
				label="공정"
				value={PRD5030_R01Filter.workplaceCd}
				optionList={workPlaceList}
				onChangeValue={(v) => setPRD5030_R01Filter({ workplaceCd: v === 'all' ? '' : v })}
			/>

			<SearchDropDownForm<SysCodeDto>
				label="품목그룹"
				value={PRD5030_R01Filter.itemGroup}
				optionList={itemGroupList}
				onChangeValue={(v) => setPRD5030_R01Filter({ itemGroup: v === 'all' ? '' : v })}
			/>

			<SearchCodeModalForm
				label="품목코드"
				value={PRD5030_R01Filter.itemCd}
				valueLabel={PRD5030_R01Filter.itemNm}
				handleFoucsId={itemCdHandleFocusId}
				onChange={getFieldHandlers('itemCd').onChange}
				onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
				onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_PRD5030_R01;
